 /**
  * Icon parameters.
  * @typedef {Object} ICON_PARAMS 
  * @property {String} color CSS literal/rgb/rgba/hex/hls/hlsa value Icon Color.
  * @property {Number} width Icon svg width.
  * @property {Number} height Icon svg height.
  * @property {ICONS} IType Icon type.
  */

 /**
  * @class
  * Build a html div icon object.
  */
 class Icon_JS {
     /**
      * @constructor
      * @param {ICON_PARAMS} pOptions Icon_JS params.
      */
     constructor(pOptions) {
         /**
          * @type {ICON_PARAMS}
          */
         let objOptions = {
             color: '',
             width: 25,
             height: 25,
             IType: JFMUI_CONST.ICONS.INFO,
         }
         Object.assign(objOptions, pOptions);

         /**
          * CSS literal/rgb/rgba/hex/hls/hlsa value Icon Color.
          * @type {String}
          */
         this.Color = objOptions.color;
         /**
          * Icon svg width.
          * @type {Number}
          */
         this.Width = objOptions.width;
         /**
          * Icon svg height.
          * @type {Number}
          */
         this.Height = objOptions.height;
         /**
          * IType Icon type.
          * @type {ICONS}
          */
         this.IType = objOptions.IType;
         /**
          * SVG icon HTML.
          * @type {String}
          */
         this.IconSvg = '';
         
         //Initialize Icon.
         this.init();
     }
     /**
      * Generate the icon template according to @see {@link ICONS} IType property.
      */
     init() {
         let strColor = '',
             strIconSvg = '';

         switch (this.IType) {
             case JFMUI_CONST.ICONS.WARNING:
                 strIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="${this.Width}" height="${this.Height}" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16" aria-label="Warning:">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                </svg>`;
                 strColor = '#664d03';
                 break;
             case JFMUI_CONST.ICONS.DANGER:
                 strIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="${this.Width}" height="${this.Height}" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16" aria-label="Danger:">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                </svg>`;
                 strColor = '#842029';
                 break;
             case JFMUI_CONST.ICONS.INFO:
                 strIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="${this.Width}" height="${this.Height}" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16" aria-label="Info:">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                    </svg>`;
                 strColor = '#084298';
                 break;
             case JFMUI_CONST.ICONS.SUCCESS:
                 strIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="${this.Width}" height="${this.Height}" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16" aria-label="Success:">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                        </svg>`;
                 strColor = '#0f5132';
                 break;
             case JFMUI_CONST.ICONS.CONFIRM:
                strIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="${this.Width}" height="${this.Height}" fill="currentColor" class="bi bi-question-circle-fill" viewBox="0 0 16 16" aria-label="Confirm:">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>
                </svg>`;
                 strColor = '#084298';
                 break;
         }

         this.Color = !this.Color ? strColor : this.Color;
         this.IconSvg  = strIconSvg;
     }
     /**
      * Generate Icon HTML.
      * @public
      * @returns {HTMLDivElement}
      */
     generateIcon() {
         let objDIV = document.createElement('DIV');
         objDIV.style.color = this.Color;
         objDIV.classList.add('me-2');
         objDIV.insertAdjacentHTML('beforeend', this.IconSvg)
         return objDIV;
     }
 }